(() => {
  const content = document.querySelector('.article__content.rte');
  const graph = document.querySelector('script[data-netrition-schema="site"]');
  if (!content || !graph) return;

  let article;
  try {
    article = JSON.parse(graph.textContent)['@graph'].find((node) => node['@type'] === 'BlogPosting');
  } catch {
    return;
  }
  if (!article) return;

  const elements = [...content.children];
  const headingText = (element) => element?.textContent?.replace(/\s+/g, ' ').trim().replace(/:$/, '').toLowerCase();
  const ingredientsIndex = elements.findIndex((element) => headingText(element) === 'ingredients');
  const instructionsIndex = elements.findIndex((element) => headingText(element) === 'preparation instructions');
  if (ingredientsIndex < 0 || instructionsIndex <= ingredientsIndex) return;

  const ingredients = elements.slice(ingredientsIndex + 1, instructionsIndex)
    .flatMap((element) => [...element.querySelectorAll('li')])
    .map((item) => item.textContent.replace(/\s+/g, ' ').trim())
    .filter(Boolean);
  const steps = elements.slice(instructionsIndex + 1)
    .filter((element) => element.matches('p, ol, ul'))
    .map((element) => element.textContent.replace(/\s+/g, ' ').trim())
    .filter(Boolean);
  if (ingredients.length < 2 || !steps.length) return;

  const recipe = {
    '@context': 'https://schema.org',
    '@type': 'Recipe',
    '@id': `${article.url}#recipe`,
    url: article.url,
    name: article.headline,
    mainEntityOfPage: article.mainEntityOfPage,
    recipeIngredient: ingredients,
    recipeInstructions: steps.map((text) => ({ '@type': 'HowToStep', text }))
  };
  if (article.image) recipe.image = article.image;
  if (article.author) recipe.author = article.author;
  if (article.datePublished) recipe.datePublished = article.datePublished;
  if (article.dateModified) recipe.dateModified = article.dateModified;

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.dataset.netritionSchema = 'recipe';
  script.textContent = JSON.stringify(recipe);
  document.head.appendChild(script);
})();
